var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphPhone = function SvgInterfaceGlyphPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.023 15.488c-.63-.015-1.423-.052-1.924-.14a15 15 0 0 1-1.653-.425 1.02 1.02 0 0 0-1.019.253L13.21 17.38a15.4 15.4 0 0 1-3.798-2.792A15.4 15.4 0 0 1 6.62 10.79l2.204-2.218c.266-.267.365-.659.253-1.019-.142-.458-.329-1.11-.424-1.652-.089-.501-.125-1.294-.141-1.924A1 1 0 0 0 7.51 3H4c-.438 0-1 .328-1 1 0 4.539 1.84 8.874 4.966 12.034C11.126 19.16 15.461 21 20 21c.672 0 1-.562 1-1v-3.51a1 1 0 0 0-.977-1.002"
  })));
};
export default SvgInterfaceGlyphPhone;